// Application constants and configurations

/**
 * Status badge configurations
 */
export const STATUS_CONFIGS = {
  active: {
    bg: 'bg-gradient-to-r from-green-500 to-green-600',
    text: 'text-white',
    label: 'Active',
    icon: 'CheckCircle'
  },
  inactive: {
    bg: 'bg-gradient-to-r from-gray-500 to-gray-600',
    text: 'text-white',
    label: 'Inactive',
    icon: 'XCircle'
  },
  suspended: {
    bg: 'bg-gradient-to-r from-red-500 to-red-600',
    text: 'text-white',
    label: 'Suspended',
    icon: 'AlertTriangle'
  },
  graduated: {
    bg: 'bg-gradient-to-r from-blue-500 to-blue-600',
    text: 'text-white',
    label: 'Graduated',
    icon: 'Award'
  }
};

/**
 * Role configurations
 */
export const ROLE_CONFIGS = {
  super_admin: {
    label: 'Super Admin',
    badgeColor: 'bg-gradient-to-r from-red-500 to-red-600',
    textColor: 'text-white'
  },
  trainer: {
    label: 'Trainer',
    badgeColor: 'bg-gradient-to-r from-blue-500 to-blue-600',
    textColor: 'text-white'
  },
  student: {
    label: 'Student',
    badgeColor: 'bg-gradient-to-r from-green-500 to-green-600',
    textColor: 'text-white'
  },
  organization_manager: {
    label: 'Org Manager',
    badgeColor: 'bg-gradient-to-r from-purple-500 to-purple-600',
    textColor: 'text-white'
  }
};

/**
 * Get status badge config
 */
export const getStatusBadge = (status) => {
  return STATUS_CONFIGS[status] || STATUS_CONFIGS.active;
};

/**
 * Get role config
 */
export const getRoleConfig = (role) => {
  return ROLE_CONFIGS[role] || ROLE_CONFIGS.student;
};

/**
 * Pagination defaults
 */
export const PAGINATION_DEFAULTS = {
  rowsPerPage: 100,
  rowsPerPageOptions: [25, 50, 100, 200]
};
